import BaseController from "confinus_ui/base_controller";
import { showModal } from "lib/overlay/modal";

export default class ProductLightboxController extends BaseController {
  public static values = {
    modalId: { type: String, default: "" },
  };

  declare private readonly modalIdValue: string;

  public handleButtonClick(evt: Event) {
    // Stop propagation: prevent any clicks leaking out
    evt.preventDefault();
    evt.stopPropagation();

    showModal({ id: this.modalIdValue });
  }
}
